import { Component } from "react";

/**
 * Last-resort safety net. A render throw anywhere below (e.g. a bad activity
 * code feeding a dynamic RegExp) used to unmount the ENTIRE app, which left the
 * Leaflet map detached and zero-sized — tiles and markers then scaled from
 * different origins ("assets on a different surface"). Catching it keeps the
 * map alive and shows a quiet retry instead of a white screen.
 */
export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("App error boundary caught:", error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="app-fatal" role="alert">
          <div className="app-fatal-box">
            <div className="app-fatal-title">SIGNAL INTERRUPTED</div>
            <div className="app-fatal-sub">The console hit an error and paused.</div>
            <button className="app-fatal-btn" onClick={() => window.location.reload()}>
              RECONNECT
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
